(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookDialogController', HandbookDialogController);

    HandbookDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Handbook', 'ProfessionalArea', 'HandbookVersion', 'CustomUser'];

    function HandbookDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Handbook, ProfessionalArea, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbook = entity;
        vm.clear = clear;
        vm.save = save;
        vm.professionalareas = ProfessionalArea.query();
        vm.handbookversions = HandbookVersion.query();
        vm.handbooks = Handbook.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbook.id !== null) {
                Handbook.update(vm.handbook, onSaveSuccess, onSaveError);
            } else {
                Handbook.save(vm.handbook, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
